import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const BalanceIcon = ({ stroke, ...props }: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return (
    <svg
      width={24}
      height={24}
      viewBox="0 1 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_11034_23236)">
        <path
          d="M9.00184 9.49793C12.4357 9.49793 15.0015 8.14046 15.0015 6.92667C15.0015 5.71299 12.4356 4.35547 9.00184 4.35547C5.56803 4.35547 3.0022 5.71299 3.0022 6.92667C3.0022 8.14046 5.56797 9.49793 9.00184 9.49793Z"
          fill={strokeColor}
        />
        <path
          d="M9.00184 19.7785C9.50303 19.7785 9.98543 19.7493 10.4443 19.6962C10.0575 19.1992 9.73763 18.6476 9.498 18.0552C9.33336 18.0607 9.16814 18.0645 9.00178 18.0645C7.03967 18.0645 5.18153 17.6757 3.76977 16.9698C3.49179 16.8308 3.23599 16.6815 3.0022 16.5234V17.2073C3.0022 18.421 5.56797 19.7785 9.00184 19.7785Z"
          fill={strokeColor}
        />
        <path
          d="M9.00189 16.3527C9.01949 16.3527 9.03681 16.3524 9.05436 16.3524C9.01921 16.0714 9.00086 15.7853 9.00086 15.495C9.00086 15.2047 9.01915 14.9188 9.05436 14.6381C9.03681 14.6381 9.01944 14.6387 9.00189 14.6387C7.03979 14.6387 5.1817 14.2499 3.76988 13.544C3.49185 13.405 3.23599 13.2557 3.0022 13.0977V13.7814C3.00225 14.9952 5.56803 16.3527 9.00189 16.3527Z"
          fill={strokeColor}
        />
        <path
          d="M9.00189 12.9269C9.17197 12.9269 9.33976 12.9234 9.50543 12.9169C9.77152 12.2641 10.1352 11.6611 10.5785 11.1264C10.0652 11.183 9.53767 11.213 9.00189 11.213C7.03979 11.213 5.1817 10.8242 3.76988 10.1183C3.49185 9.97922 3.23599 9.82995 3.0022 9.67188V10.3557C3.00225 11.5695 5.56803 12.9269 9.00189 12.9269Z"
          fill={strokeColor}
        />
        <path
          d="M11.5743 12.6576C11.2034 13.2152 10.9384 13.8489 10.808 14.5299C10.7478 14.8439 10.7161 15.1677 10.7161 15.4989C10.7161 15.7479 10.7342 15.9927 10.7686 16.2324C10.853 16.821 11.0374 17.3777 11.3041 17.8848C11.5839 18.4169 11.954 18.8944 12.3943 19.2964C13.3091 20.132 14.5258 20.6423 15.8595 20.6423C18.6956 20.6423 21.0029 18.335 21.0029 15.4989C21.0029 12.6628 18.6956 10.3555 15.8595 10.3555C15.5664 10.3555 15.279 10.3805 14.9991 10.4278C13.5733 10.6689 12.3453 11.4987 11.5743 12.6576Z"
          fill={strokeColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_11034_23236">
          <rect
            width={18}
            height={18}
            fill={theme.palette.background.paper}
            transform="translate(3.0022 3.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
